import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from '../index.less';

const cx = classNames.bind(styles);


const defaultProps = {
  color: 'rgba(0, 0, 0, .3)',
};
const propTypes = {
  color: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]).isRequired,
};

const Label = ({ color, children }) => (
  <label
    className={cx('label')}
    style={{ color }}
  >
    {children}
  </label>
);

Label.defaultProps = defaultProps;
Label.propTypes = propTypes;
export default Label;



// WEBPACK FOOTER //
// ./src/components/page/FloatLabelInput/components/Label.jsx